import { api } from './config/api'
import { LICENSE_API_URL, RENOVACAO_API_URL } from './config/constants'
import { Licenca, PagamentoLicenca, PixRenovacao, PlanoRenovacao } from './models'

// Renovação de licença via Pix: planos, valores e confirmação ficam todos no backend

export const getSituacaoLicenca = async (): Promise<Licenca | null> => {
  const { data } = await api.get<Licenca | null>(`${RENOVACAO_API_URL}/Situacao`)
  return data
}

export const getPlanosRenovacao = async (): Promise<PlanoRenovacao[]> => {
  const { data } = await api.get<PlanoRenovacao[]>(`${RENOVACAO_API_URL}/Planos`)
  return data ?? []
}

export const getPagamentosLicenca = async (): Promise<PagamentoLicenca[]> => {
  const { data } = await api.get<PagamentoLicenca[]>(`${RENOVACAO_API_URL}/Pagamentos`)
  return data ?? []
}

export const gerarPix = async (id_plano: number): Promise<PixRenovacao> => {
  const { data } = await api.post<PixRenovacao>(`${RENOVACAO_API_URL}/Pix`, { id_plano })
  return data
}

export const consultarPix = async (id: number): Promise<PixRenovacao> => {
  const { data } = await api.get<PixRenovacao>(`${RENOVACAO_API_URL}/Pix/${id}`)
  return data
}

// cadastro com 30 dias grátis (mesmo endpoint da landing page)
export const cadastrarTrial = async (s_nome_loja: string, s_email: string, s_telefone: string) => {
  await api.post(`${LICENSE_API_URL}/CadastrarTrial`, undefined, {
    params: { s_nome_loja, s_email, s_telefone },
  })
}
